import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { IRootState } from "../../state";
import { PAGE_TITLE_TO_PATH_MAPPING } from "../../navigation/params";
// import PageTitle from "../PageTitle/PageTitle";
import { layoutContentStyle } from "./ContentLayout.style";
import { useLocation } from "react-router-dom";
import { usePageTitleContext } from "../../context/PageTitleContext";
import { useSelector } from "react-redux";
import { PageTitle, WellnessPlanTitle } from "../index";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";

type Props = {
  children: React.ReactNode;
};
type IPageTitleProps= {
  pageTitle: string,
  showBackButton:boolean,
  showNotificationIcon:boolean
}

const ContentLayout = (props: Props) => {
  const { children } = props;

  const { user } = useSelector((state: IRootState) => state.user);
  const { pageTitle, setPageTitle, billCycle, showBackButtonOverride } = usePageTitleContext();
  const location = useLocation();
  const pageTitleInfo: IPageTitleProps =
    PAGE_TITLE_TO_PATH_MAPPING[
      location.pathname as keyof typeof PAGE_TITLE_TO_PATH_MAPPING
    ];

  useEffect(() => {
    if (pageTitleInfo) setPageTitle(pageTitleInfo.pageTitle);
  }, [location]);

  // Function to determine which component
  // to render based on pageTitle using switch
  const renderTitleComponent = () => {
    switch (pageTitle) {
    case "Choose Your Subscription":
      return <WellnessPlanTitle
        showBackButton={showBackButtonOverride ?? pageTitleInfo?.showBackButton ?? false}
        pageTitle={pageTitle}
        user={user}
        showNotificationIcon={pageTitleInfo?.showNotificationIcon??true}
        mixpanelTrigger={MIXPANEL_EVENTS.BACK_BUTTON_CLICK_PLAN_DETAILS}
      />;
    case "Choose Your Billing Option":
      return <WellnessPlanTitle
        showBackButton={showBackButtonOverride ?? pageTitleInfo?.showBackButton ?? false}
        pageTitle={pageTitle}
        user={user}
        showNotificationIcon={pageTitleInfo?.showNotificationIcon??true}
        mixpanelTrigger={MIXPANEL_EVENTS.BACK_BUTTON_CLICK_CONFIRM_PAY}
        billCycle={billCycle}
      />;
    default:
      return (
        <PageTitle
          showBackButton={showBackButtonOverride ?? pageTitleInfo?.showBackButton ?? false}
          pageTitle={pageTitle}
          user={user}
          showNotificationIcon={pageTitleInfo?.showNotificationIcon??true}

        />
      );
    }
  };

  return (
    <Box className="w-full h-full flex flex-col gap-5">
      {/* Header section start */}
      {user && renderTitleComponent()}
      {/* Header section end */}
      {/* Child components outlet */}
      <Box sx={layoutContentStyle}>{children}</Box>
    </Box>
  );
};

export default ContentLayout;
